import { black } from '../../../constants/colors';

const typography = {
  fontFamily: 'RobotoRegular,'
  + '-apple-system,system-ui,BlinkMacSystemFont,'
  + '"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif',
  color: black,
  htmlFontSize: 10,
  useNextVariants: true,
};

export default typography;
